// extracted by mini-css-extract-plugin
module.exports = {"notificationModalSelect":"L5lvp"};